import { fetchAuthSession } from 'aws-amplify/auth';
import { getStoredIdToken, isStoredTokenExpired, isStoredTokenIssuedInFuture } from '../authToken';

type Refresh = () => Promise<string>;

const refreshFromAmplify: Refresh = async () => {
  const session = await fetchAuthSession({ forceRefresh: true });
  return session.tokens?.idToken?.toString() || '';
};

/**
 * The ID token to send to the backend. A tab left open past the token's life, or one whose token has gone
 * missing, would otherwise send an expired token (or none) and get "Unauthorized". This refreshes it first. If
 * the refresh fails it falls back to whatever is stored, and returns "" only when there is no session at all.
 */
export async function getFreshIdToken(refresh: Refresh = refreshFromAmplify): Promise<string> {
  let token = getStoredIdToken();
  if (!token || isStoredTokenExpired(token) || isStoredTokenIssuedInFuture(token)) {
    try {
      token = (await refresh()) || getStoredIdToken();
    } catch {
      token = getStoredIdToken();
    }
  }
  return token;
}
